import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD, getDateToCurrent } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { device_about, project_list, building_list, floor_list, device_event_history, device_onoffline_history, building_trend, get_firmware_info, upup_firmware, set_device_wifi, device_cmd_config, get_device_cmd_config, real_time_view, midu_analysis, refresh_device_pic_ajax } from '@/api/pests';
import ImageMap from '@/view/components/imageMap/imageMap';
import { ChartStepLine, ChartLine, ChartStepLineFang, ChartLineMul, ChartStepLineYIHai, ChartStepLineYIHai1, ChartStepLineYIHai2, ChartStepLineYIHai3, ChartStepLineYIHai4 } from "@/components/charts";
import dataSummaryVue from '../../../single-page/home/dataSummary/dataSummary.vue';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      miduTime: {
        start_time: null,
        end_time: null
      },
      btnList: [{
        value: 30,
        label: '最近一个月',
        methods: this.qsTimeChange,
        checked: true
      }, {
        value: 90,
        label: '最近三个月',
        methods: this.qsTimeChange
      }, {
        value: 183,
        label: '最近半年',
        methods: this.qsTimeChange
      }, {
        value: 365,
        label: '最近一年',
        methods: this.qsTimeChange
      }, {
        value: 1095,
        label: '最近三年',
        methods: this.qsTimeChange
      }],
      currLegend: '在线离线',
      total_run_time_zhanban: null,
      total_run_time: null,
      uploadLoading: false,
      currImgTime: null,
      carouselIndex: 0,
      height: 300,
      lineMulValue: [],
      lineMulLegend: [],
      lineMulXaxis: [],
      columnsMidu: [{
        title: '虫害各类',
        key: 'name'
      }, {
        title: '数量',
        key: 'num'
      }, {
        title: '与上次对比(增长)',
        key: 'insect_zz'
      }, {
        title: '增长率',
        key: 'insect'
      }],
      dataMidu: [],
      miduArr: [],
      //飞虫列表数据
      refControl: 'refControl',
      refWifi: 'refWifi',
      is_update: 0,
      //是否可以升级
      lineValue: {},
      time0: [],
      time: [],
      time1: [],
      onOffData: {},
      qsData: {},
      start_time: null,
      end_time: null,
      start_time1: null,
      end_time1: null,
      deviceEventHistory: [],
      axis: [],
      //已存在坐标
      imageSrc: null,
      floorListData: [],
      //楼层列表
      buildingListData: [],
      //平面图列表
      projectListData: [],
      //项目记录
      deviceTypeData: [],
      //设备分类
      devicePurposeData: [],
      //设备用途
      defaultList: [],
      maintainList: [],
      sjbtnList: [{
        name: '最近7天',
        value: 7,
        methods: this.sjStatus,
        check: false
      }, {
        name: '最近15天',
        value: 15,
        methods: this.sjStatus,
        check: true
      }, {
        name: '最近1个月',
        value: 30,
        methods: this.sjStatus,
        check: false
      }],
      ydbtnList: [{
        name: '最近7天',
        value: 7,
        methods: this.ydStatus,
        check: false
      }, {
        name: '最近15天',
        value: 15,
        methods: this.ydStatus,
        check: true
      }, {
        name: '最近1个月',
        value: 30,
        methods: this.ydStatus,
        check: false
      }],
      qsbtnList: [{
        name: '最近15天',
        value: 15,
        methods: this.qstStatus,
        check: true
      }, {
        name: '最近1个月',
        value: 30,
        methods: this.qstStatus,
        check: false
      }, {
        name: '最近3个月',
        value: 90,
        methods: this.qstStatus,
        check: false
      }],
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      formModel: {
        device_name: null,
        //设备名称
        device_id: null,
        //设备ID
        device_code: null,
        //设备编码
        device_type_code: null,
        //设备分类编码
        device_purpose_code: null,
        //设备用途编码
        project_code: null,
        //项目编码
        building_code: null,
        //平面图编码
        floor_code: null,
        //楼层编码
        remark: null,
        //备注
        file_path: null,
        //设备图
        x_axis: '1',
        y_axis: '1'
      },
      wifiModel: {
        wifi_ssid: null,
        wifi_pass: null
      },
      wifiRules: {
        wifi_ssid: [{
          required: true,
          message: '更换WIFI不能为空',
          trigger: 'blur'
        }],
        wifi_pass: [{
          required: true,
          message: 'WIFI密码不能为空',
          trigger: 'blur'
        }]
      },
      controlModel: {
        lamp_time: [{
          time: []
        }],
        shot_time: [{
          time: ''
        }],
        lamp_lifetime: null,
        zhanban_lifetime: null,
        zhanban_alarm_value: null,
        midu_warning_value: null
      },
      controlRules: {
        lamp_time: [{
          required: false,
          type: 'array',
          message: '开机时间不能为空',
          trigger: 'blur'
        }],
        shot_time: [{
          required: false,
          type: 'array',
          message: '定时拍摄不能为空',
          trigger: 'blur'
        }],
        lamp_lifetime: [{
          required: true,
          type: 'number',
          message: '灯管寿命不能为空',
          trigger: 'blur'
        }],
        zhanban_lifetime: [{
          required: true,
          type: 'number',
          message: '粘板寿命不能为空',
          trigger: 'blur'
        }],
        zhanban_alarm_value: [{
          required: true,
          type: 'number',
          message: '单板报警值不能为空',
          trigger: 'blur'
        }],
        midu_warning_value: [{
          required: true,
          type: 'number',
          message: '密度预警差值不能为空',
          trigger: 'blur'
        }]
      },
      formRules: {},
      stepLegend: [],
      stepLegend1: ['报警信息', '触发数据'],
      series: [],
      series1: [],
      reqBase: {
        page: 1,
        page_size: 15
      },
      hasMore: false,
      loadingMore: false,
      loadingFirmware: false,
      //加载是否有版本更新
      isChrome: true,
      realtimeIndex: 0,
      realtimeint: null
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    cate_code: {} //分类

  },
  components: {
    ImageMap: ImageMap,
    ChartStepLine: ChartStepLine,
    ChartLine: ChartLine,
    ChartStepLineFang: ChartStepLineFang,
    ChartLineMul: ChartLineMul,
    ChartStepLineYIHai: ChartStepLineYIHai,
    ChartStepLineYIHai1: ChartStepLineYIHai1,
    ChartStepLineYIHai2: ChartStepLineYIHai2,
    ChartStepLineYIHai3: ChartStepLineYIHai3,
    ChartStepLineYIHai4: ChartStepLineYIHai4
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: (_methods = {
    getMudiTime: function getMudiTime(value) {
      var start = getDateToCurrent(-value);
      var end = getDateToCurrent(0);
      this.$set(this.miduTime, 'start_time', start);
      this.$set(this.miduTime, 'end_time', end);
    },

    /**
     * 密度分析时间修改
     */
    qsTimeChange: function qsTimeChange(value) {
      for (var i = 0; i < this.btnList.length; i++) {
        if (value === this.btnList[i].value) {
          this.btnList[i].checked = true;
        } else {
          this.btnList[i].checked = false;
        }
      }

      this.getMudiTime(value);
      this.miduAnalysis();
    },
    legendChange: function legendChange(value) {
      var _this = this;

      var index = this.stepLegend.indexOf(value);

      if (index > -1) {
        this.$nextTick(function () {
          debugger;
          var ref = 'ChartStepLineYIHai' + index;

          _this.$refs[ref].init();
        });
      }
    },
    downImg: function downImg(img) {
      window.open(img);
    },

    /**
     * 跑马灯change
     */
    carouseChange: function carouseChange(oldValue, value) {
      var _this$dataMidu;

      this.dataMidu.splice(0);
      this.currImgTime = this.miduArr[value].timestamp;

      (_this$dataMidu = this.dataMidu).push.apply(_this$dataMidu, _toConsumableArray(this.miduArr[value].data));
    },

    /**
     * 蝇害密度分析
     */
    miduAnalysis: function miduAnalysis() {
      var _this2 = this;

      this.miduArr.splice(0);
      this.lineMulValue.splice(0);
      this.lineMulLegend.splice(0);
      this.lineMulXaxis.splice(0);
      midu_analysis(_objectSpread({
        device_id: this.setData.device_id
      }, this.miduTime)).then(function (res) {
        _this2.carouselIndex = 0;

        if (res.result === 0) {
          //拼接多曲线数据
          var line_chart = res.body.line_chart;
          var big = [];
          var small = [];

          for (var j in line_chart) {
            var itemj = line_chart[j];
            big.push(itemj.big_insect);
            small.push(itemj.small_insect);

            _this2.lineMulXaxis.push(itemj.time);
          }

          if (big.length > 0) {
            _this2.lineMulValue.push({
              data: big,
              name: '大飞虫',
              type: 'line'
            }, {
              data: small,
              name: '小飞虫',
              type: 'line'
            });

            _this2.lineMulLegend.push('大飞虫', '小飞虫');
          }

          var arr = res.body.list;

          for (var i in arr) {
            var item = arr[i];

            _this2.miduArr.push(_objectSpread({}, item, {
              data: [{
                name: '大飞虫',
                num: item.big_insect,
                insect: item.big_insect_zzl,
                //增长率
                insect_zz: item.big_insect_zz //较上次增长

              }, {
                name: '小飞虫',
                num: item.small_insect,
                insect: item.small_insect_zzl,
                insect_zz: item.small_insect_zz
              }]
            }));
          }

          if (_this2.miduArr && _this2.miduArr.length > 0) {
            _this2.carouseChange(0, 0);
          }
        }
      });
    },

    /**
     * 实时查看
     */
    realTimeView: function realTimeView() {
      var _this3 = this;

      real_time_view({
        device_id: this.setData.device_id
      }).then(function (res) {
        if (res.result === 0) {
          if (_this3.realtimeint) {
            clearInterval(_this3.realtimeint);
          }

          _this3.realtimeIndex = 0;
          _this3.realtimeint = setInterval(function () {
            if (_this3.realtimeIndex === 10) {
              clearInterval(_this3.realtimeint);
            } else {
              _this3.realtimeIndex++;
              refresh_device_pic_ajax({
                device_id: _this3.setData.device_id
              }).then(function (res1) {
                if (res1.result === 0) {
                  clearInterval(_this3.realtimeint);

                  _this3.miduAnalysis();
                }
              });
            }
          }, 6000);

          _this3.$Message.success(res.errorMsg);
        } else {
          _this3.$Message.error(res.errorMsg);
        }
      });
    },
    lampchange: function lampchange(arr, index) {
      if (arr) {
        this.$set(this.controlModel.lamp_time, index, {
          time: arr,
          start_time: arr[0],
          end_time: arr[1]
        });
      }
    },
    handleAddShot: function handleAddShot() {
      this.controlModel.shot_time.push({
        time: ''
      });
    },
    handleAddLamp: function handleAddLamp() {
      this.controlModel.lamp_time.push({
        time: []
      });
    },

    /**
     * 删除item
     */
    handleControlRemove: function handleControlRemove(index, str) {
      this.controlModel[str].splice(index, 1);
    },
    handleSubmitWifi: function handleSubmitWifi() {
      var _this4 = this;

      this.$refs[this.refWifi].validate(function (valid) {
        if (valid) {
          set_device_wifi(_objectSpread({}, _this4.wifiModel, {
            device_id: _this4.setData.device_id
          })).then(function (res) {
            if (res.result === 0) {
              _this4.$Message.success(res.errorMsg);

              _this4.$set(_this4.formModel, 'wifi_ssid', _this4.wifiModel.wifi_ssid);

              _this4.handleWifiReset();
            } else {
              _this4.$Message.error(res.errorMsg);
            }
          });
        } else {}
      });
    },
    handleWifiReset: function handleWifiReset() {
      this.$refs[this.refWifi].resetFields();
    },
    handleSubmitControl: function handleSubmitControl(name) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          var lamp_time = true;
          var shot_time = true; //控制设置

          console.log(_objectSpread({}, _this5.controlModel, {
            device_id: _this5.setData.device_id
          }));

          for (var i = 0; i < _this5.controlModel.lamp_time.length > 0; i++) {
            var item = _this5.controlModel.lamp_time[i];

            if (!item.start_time) {
              lamp_time = false;
              break;
            }
          }

          for (var _i = 0; _i < _this5.controlModel.shot_time.length > 0; _i++) {
            var _item = _this5.controlModel.shot_time[_i];

            if (!_item.time) {
              shot_time = false;
              break;
            }
          }

          if (!lamp_time) {
            _this5.$Message.error("开机时间不能为空");

            return false;
          }

          if (!shot_time) {
            _this5.$Message.error("抓拍时间不能为空");

            return false;
          }

          device_cmd_config(_objectSpread({}, _this5.controlModel, {
            device_id: _this5.setData.device_id
          })).then(function (res) {
            if (res.result === 0) {
              _this5.$Message.success(res.errorMsg); // this.$set(this.formModel,'wifi_ssid',this.wifiModel.wifi_ssid)
              // this.handleWifiReset()

            } else {
              _this5.$Message.error(res.errorMsg);
            }
          });
        } else {}
      });
    },
    handleControlReset: function handleControlReset(name) {
      this.$refs[name].resetFields();
    },

    /**
     * 趋势图
     */
    qstStatus: function qstStatus(num) {
      for (var i = 0; i < this.qsbtnList.length; i++) {
        if (num === this.qsbtnList[i].value) {
          this.$set(this.qsbtnList[i], 'check', true);
        } else {
          this.$set(this.qsbtnList[i], 'check', false);
        }
      }

      var start = getDateToCurrent(-num);
      var end = getDateToCurrent(0);
      this.start_time1 = start;
      this.end_time1 = end;
      this.$set(this.time1, 0, start);
      this.$set(this.time1, 1, end);
      this.getbuildingTrend();
    },

    /**
     * 事件记录
     */
    sjStatus: function sjStatus(num) {
      for (var i = 0; i < this.sjbtnList.length; i++) {
        if (num === this.sjbtnList[i].value) {
          this.$set(this.sjbtnList[i], 'check', true);
        } else {
          this.$set(this.sjbtnList[i], 'check', false);
        }
      }

      var start = getDateToCurrent(-num);
      var end = getDateToCurrent(0);
      this.start_time1 = start;
      this.end_time1 = end;
      this.$set(this.time0, 0, start);
      this.$set(this.time0, 1, end);
      this.getDeviceHistory();
    },

    /**
     * 运行状态
     */
    ydStatus: function ydStatus(num) {
      for (var i = 0; i < this.ydbtnList.length; i++) {
        if (num === this.ydbtnList[i].value) {
          this.$set(this.ydbtnList[i], 'check', true);
        } else {
          this.$set(this.ydbtnList[i], 'check', false);
        }
      }

      var start = getDateToCurrent(-num);
      var end = getDateToCurrent(0);
      this.start_time = start;
      this.end_time = end;
      this.$set(this.time, 0, start);
      this.$set(this.time, 1, end);
      this.getOnOffLine();
    },
    changeTime0: function changeTime0(arr) {
      var _this$time;

      this.time0.splice(0);
      this.start_time0 = arr[0];
      this.end_time0 = arr[1];

      (_this$time = this.time0).push.apply(_this$time, _toConsumableArray(arr)); //调用事件记录接口


      this.getDeviceHistory();
    },
    changeTime: function changeTime(arr) {
      var _this$time2;

      this.time.splice(0);
      this.start_time = arr[0];
      this.end_time = arr[1];

      (_this$time2 = this.time).push.apply(_this$time2, _toConsumableArray(arr));

      this.getOnOffLine();
    },
    changeTime1: function changeTime1(arr) {
      var _this$time3;

      this.time1.splice(0);
      this.start_time1 = arr[0];
      this.end_time1 = arr[1];

      (_this$time3 = this.time1).push.apply(_this$time3, _toConsumableArray(arr));

      this.getbuildingTrend();
    },
    clickImg: function clickImg(url) {
      this.visible = true;
      this.imgName = url;
    },

    /**
     * 获取楼层
     */
    getFloor: function getFloor(val, callback) {
      for (var i = 0; i < this.floorListData.length; i++) {
        var list = this.floorListData[i];

        if (val === list.floor_code) {
          this.imageSrc = list.file_url;
          break;
        }
      }

      if (callback) {
        callback();
      }
    },

    /**
     * 获取坐标
     */
    getAxis: function getAxis(axis) {
      this.$set(this.formModel, 'x_axis', axis.x);
      this.$set(this.formModel, 'y_axis', axis.y);
    },

    /**
     * 项目改变
     */
    changeProject: function changeProject(val, callback) {
      var _this6 = this;

      this.$set(this.formModel, 'building_code', null);
      this.$set(this.formModel, 'floor_code', null);
      building_list({
        page: 0,
        page_size: 15,
        project_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this6.buildingListData = res.body.list || [];

          if (callback) {
            callback();
          }
        } else {}
      });
    },

    /**
     * 改变平面图
     */
    changeBuilding: function changeBuilding(val, callback) {
      var _this7 = this;

      this.$set(this.formModel, 'floor_code', null);
      floor_list({
        page: 0,
        page_size: 15,
        building_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this7.floorListData = res.body.list || [];

          if (callback) {
            callback();
          }
        }
      });
    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      return true;
    },

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this;

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'file_path', res.body.file_path);
      this.uploadList.push({
        status: 'finished',
        url: res.body.file_path,
        name: file.name
      });
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "clientChange", function clientChange(val) {
    this.$set(this.fileData, 'client_id', val);
    this.hasDisabled = false;
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    var _this8 = this;

    //获取设备分类和用途
    device_about({
      cate_code: this.cate_code
    }).then(function (res) {
      if (res.result === 0) {
        _this8.deviceTypeData = res.body.device_type || [];
        _this8.devicePurposeData = res.body.device_purpose || [];
      }
    }); //项目列表

    project_list({
      page: 0,
      page_size: 15
    }).then(function (res) {
      if (res.result === 0) {
        _this8.projectListData = res.body.list || [];
      }
    });
  }), _defineProperty(_methods, "handleUpload", function handleUpload(file, data) {
    this.uploadList.splice(0);
    return true;
  }), _defineProperty(_methods, "getOnOffLine", function getOnOffLine() {
    var _this9 = this;

    this.series.splice(0);
    this.stepLegend.splice(0);
    var obj = {
      device_id: this.setData.device_id,
      start_time: this.start_time,
      end_time: this.end_time
    };

    if (this.cate_code === 'VTKaxJHQ2222') {
      obj['cate_code'] = this.cate_code;
    }

    device_onoffline_history(obj).then(function (res) {
      if (res.result === 0) {
        var data = res.body.onoffline;
        var arr1Data = [];
        var arr1X = [];
        var _obj = {}; //在离线

        for (var i in data) {
          var list = data[i];
          _obj[list.x_axis] = list.status === 2 ? 1 : 0;
          arr1Data.push(list.status === 2 ? 1 : 0);
          arr1X.push(list.x_axis);
        }

        _this9.$set(_this9, 'onOffData', _obj);

        var gwhf = res.body.gwhf || []; //高温/恢复

        var arr2Data = [];
        var arr2X = [];

        for (var j in gwhf) {
          var listj = gwhf[j];
          arr2Data.push(listj.cid === 66 ? 1 : 0);
          arr2X.push(listj.create_timesec);
        } //电量趋势


        var dcdl = res.body.dcdl;
        var arr3Data = [];
        var arr3X = [];

        for (var l in dcdl) {
          var listl = dcdl[l];
          var pint = listl.pint;
          arr3Data.push(pint[0]);
          arr3X.push(listl.create_timesec);
        } //维保


        var wb = res.body.wb;
        var arr4Data = [];
        var arr4X = [];

        for (var s in wb) {
          var lists = wb[s];
          arr4Data.push(1);
          arr4X.push(lists.create_timesec);
        } //运行时间


        if (res.body.total_run_time_dengguan) {
          _this9.total_run_time = res.body.total_run_time_dengguan;
        }

        if (res.body.total_run_time_zhanban) {
          _this9.total_run_time_zhanban = res.body.total_run_time_zhanban;
        } //紫外线强度


        var zwxqd = res.body.zwxqd; //紫外线开关

        var zwxkg = res.body.zwxkg;
        var zwxData = [];
        var qd = [];
        var qdx = [];
        var lastqdx = 0;

        for (var _i2 in zwxqd) {
          qd.push(zwxqd[_i2].dengji);
          qdx.push(zwxqd[_i2].create_timesec);
        }

        if (zwxqd && zwxqd.length > 0) {
          lastqdx = zwxqd[zwxqd.length - 1].alarm_time2;
        }

        var kg = [];
        var kgx = [];
        var lastkgx = 0;

        for (var _i3 in zwxkg) {
          kg.push(zwxkg[_i3].status);
          kgx.push(zwxkg[_i3].device_utc);
        }

        if (zwxkg && zwxkg.length > 0) {
          lastkgx = zwxkg[zwxkg.length - 1].alarm_time2;
        }

        zwxData.push({
          name: '紫外线强度',
          key: 1,
          type: 'line',
          data: qd,
          xaxis: qdx,
          yaxis: []
        });
        zwxData.push({
          name: '紫外线灯开/闭',
          key: 2,
          type: 'line',
          step: 'end',
          data: kg,
          xaxis: kgx,
          yaxis: []
        }); // 粘板信息

        var zbxx = res.body.zbxx;
        var zbxxData = [];
        var zbxxX = [];

        for (var _s in zbxx) {
          var _lists = zbxx[_s];
          zbxxData.push([_lists.big_insect, _lists.small_insect]);
          zbxxX.push(_lists.timestamp);
        } //温湿度信息


        var wsd = res.body.wsd;
        var wsdData = [];
        var wsdX = [];

        for (var _s2 in wsd) {
          var _lists2 = wsd[_s2];
          wsdData.push([_lists2.wendu, _lists2.shidu]);
          wsdX.push(_lists2.create_timesec);
        }

        if (_this9.cate_code === 'VTKaxJHQ2222') {
          _this9.stepLegend.splice(0);

          _this9.series.splice(0);

          _this9.stepLegend.push('在线离线', '紫外线信息', '粘板信息', '温湿度信息', '维保'); // this.currLegend=this.stepLegend[0]


          _this9.series.push({
            name: '在线离线',
            key: 1,
            type: 'line',
            data: arr1Data,
            xaxis: arr1X,
            yaxis: []
          }, {
            name: '紫外线信息',
            type: 'line',
            key: 2,
            data: zwxData,
            xaxis: []
          }, {
            name: '粘板信息',
            type: 'line',
            key: 3,
            data: zbxxData,
            xaxis: zbxxX
          }, {
            name: '温湿度信息',
            type: 'line',
            key: 4,
            data: wsdData,
            xaxis: wsdX
          }, {
            name: '维保',
            type: 'line',
            key: 5,
            data: arr4Data,
            xaxis: arr4X
          });

          _this9.legendChange(_this9.currLegend);
        } else {
          _this9.stepLegend.splice(0);

          _this9.stepLegend.push('在线离线', '高温/恢复', '电量趋势', '维保');

          _this9.series.splice(0);

          _this9.series.push({
            name: '在线离线',
            key: 1,
            type: 'line',
            data: arr1Data,
            xaxis: arr1X,
            yaxis: []
          }, {
            name: '高温/恢复',
            type: 'line',
            key: 2,
            data: arr2Data,
            xaxis: arr2X
          }, {
            name: '电量趋势',
            type: 'line',
            key: 3,
            data: arr3Data,
            xaxis: arr3X
          }, {
            name: '维保',
            type: 'line',
            key: 4,
            data: arr4Data,
            xaxis: arr4X
          });
        }
      } else {}
    });
  }), _defineProperty(_methods, "loadingMoreHistory", function loadingMoreHistory() {
    this.reqBase.page++;
    this.loadingMore = true;
    this.historyEvent();
  }), _defineProperty(_methods, "getDeviceHistory", function getDeviceHistory() {
    this.deviceEventHistory.splice(0);
    this.historyEvent();
  }), _defineProperty(_methods, "historyEvent", function historyEvent(callback) {
    var _this10 = this;

    var obj = _objectSpread({}, this.reqBase, {
      device_id: this.setData.device_id,
      start_time: this.time0[0],
      end_time: this.time0[1]
    });

    if (this.cate_code === 'VTKaxJHQ2222') {
      obj['cate_code'] = this.cate_code;
    }

    device_event_history(obj).then(function (res) {
      var body = res.body.list || [];
      _this10.loadingMore = false;

      if (body.length === _this10.reqBase.page_size) {
        _this10.hasMore = true;
      } else {
        _this10.hasMore = false;
      }

      for (var i in body) {
        var item = body[i]; //判断是左侧还是右侧进入

        if (item.alarm_type_code === '-1') {
          var pint = item.pint;

          if (pint && pint.length > 1) {
            var status = pint[0];

            if (status === 48) {
              item.alarm_type_name = '高温恢复';
            }
          }
        } else if (item.alarm_type_code === '90') {
          var _pint = item.pint;

          if (_pint && _pint.length > 2) {
            var postion = _pint[1];

            if (postion === 0) {
              item.alarm_type_name = item.alarm_type_name + '(无方法)';
            } else if (postion === 1) {
              item.alarm_type_name = item.alarm_type_name + '(左向侵入)';
            } else if (postion === 2) {
              item.alarm_type_name = item.alarm_type_name + '(右向侵入)';
            }
          }
        }

        _this10.deviceEventHistory.push(item);
      }
    });
  }), _defineProperty(_methods, "getbuildingTrend", function getbuildingTrend() {
    var _this11 = this;

    this.series1.splice(0);
    building_trend({
      device_id: this.setData.device_id,
      start_time: this.start_time1,
      end_time: this.end_time1
    }).then(function (res) {
      if (res.result === 0) {
        var data = res.body; //报警信息

        var alarm = data.alarm;
        var arr3Data = [];
        var arr3X = [];

        for (var l in alarm) {
          var listl = alarm[l];
          arr3Data.push(listl.alarm_num);
          arr3X.push(listl.x_axis);
        } //心跳


        var xintiao = data.xintiao;
        var arr4Data = [];
        var arr4X = [];

        for (var s in xintiao) {
          var lists = xintiao[s];
          arr4Data.push(lists.xintiao_num);
          arr4X.push(lists.x_axis);
        }

        _this11.series1.push({
          name: '报警信息',
          type: 'line',
          key: 1,
          data: arr3Data,
          xaxis: arr3X
        }, {
          name: '触发数据',
          type: 'line',
          key: 2,
          data: arr4Data,
          xaxis: arr4X
        });
      } else {}
    });
  }), _defineProperty(_methods, "getFirmwareInfo", function getFirmwareInfo() {
    var _this12 = this;

    this.loadingFirmware = true;
    get_firmware_info({
      device_id: this.setData.device_id
    }).then(function (res) {
      _this12.loadingFirmware = false;

      if (res.result === 0) {
        if (res.body.firmware && res.body.firmware.length > 0) {
          _this12.is_update = res.body.firmware[0].is_update;

          if (_this12.is_update === 0) {
            _this12.$Message.info("已经是最新版本");
          } else {
            _this12.$Message.success("检测出可升级的固件");
          }
        } else {
          _this12.is_update = 0;

          _this12.$Message.error("暂无可升级的固件");
        }
      } else {
        _this12.is_update = 0;

        _this12.$Message.error("暂无可升级的固件");
      }
    });
  }), _defineProperty(_methods, "uploadFirmware", function uploadFirmware() {
    var _this13 = this;

    this.uploadLoading = true;
    upup_firmware({
      device_id: this.setData.device_id
    }).then(function (res) {
      _this13.uploadLoading = false;

      if (res.result === 0) {
        _this13.$Message.success(res.errorMsg); // this.getFirmwareInfo()

      } else {
        _this13.$Message.error(res.errorMsg);
      }
    });
  }), _defineProperty(_methods, "initParams", function initParams() {
    var start = getDateToCurrent(-15);
    var end = getDateToCurrent(0); // let start='2021-12-01'
    // let end='2021-12-31'

    this.start_time = start;
    this.start_time1 = start;
    this.end_time = end;
    this.end_time1 = end;
    this.time0.push(this.start_time, this.end_time);
    this.time.push(this.start_time, this.end_time);
    this.time1.push(this.start_time1, this.end_time1);
  }), _defineProperty(_methods, "getDeviceCmdConfig", function getDeviceCmdConfig() {
    var _this14 = this;

    get_device_cmd_config({
      device_id: this.setData.device_id
    }).then(function (res) {
      if (res.result === 0) {
        var data = res.body;

        if (data.hasOwnProperty('shot_time') && data.shot_time.length > 0) {
          var _this14$controlModel$;

          _this14.controlModel.shot_time.splice(0);

          (_this14$controlModel$ = _this14.controlModel.shot_time).push.apply(_this14$controlModel$, _toConsumableArray(data.shot_time));
        }

        if (data.hasOwnProperty('lamp_time') && data.lamp_time.length > 0) {
          _this14.controlModel.lamp_time.splice(0);

          for (var i in data.lamp_time) {
            var item = data.lamp_time[i];

            _this14.controlModel.lamp_time.push(_objectSpread({
              time: [item.start_time, item.end_time]
            }, item));
          }
        }

        if (data.hasOwnProperty('info') && data.info.lamp_lifetime !== '') {
          Object.assign(_this14.controlModel, data.info);
        }
      }
    });
  }), _defineProperty(_methods, "handleFocus", function handleFocus() {
    this.$refs.password.type = 'password';
  }), _defineProperty(_methods, "handleBlur", function handleBlur() {
    this.$refs.password.type = 'text';
  }), _methods),
  mounted: function mounted() {
    var _this15 = this;

    var nav = window.navigator.userAgent;

    if (nav.includes('chrome') > -1) {
      this.isChrome = true;
    } else {
      this.isChrome = false;
    }

    this.initParams();
    this.getOnOffLine();
    this.getDeviceHistory();
    this.getbuildingTrend();
    this.getDeviceCmdConfig();
    this.getMudiTime(30);
    this.miduAnalysis();

    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
        this.uploadList.push({
          status: 'finished',
          url: this.setData.file_path,
          name: this.setData.file_path
        });
        this.$set(this, 'axis', [{
          x: this.setData.x_axis,
          y: this.setData.y_axis
        }]);
        console.log(this.axis);
        this.$set(this.formModel, 'contract_time', [formatYMD(this.setData.contract_start * 1000), formatYMD(this.setData.contract_end * 1000)]);
        this.$set(this.formModel, 'maintain_start', formatYMD(this.setData.maintain_start * 1000)); //项目管理

        this.changeProject(this.formModel.project_code, function () {
          //设置平面图
          _this15.$set(_this15.formModel, 'building_code', _this15.setData.building_code); //平面图修改


          _this15.changeBuilding(_this15.formModel.building_code, function () {
            //设置楼层
            _this15.$set(_this15.formModel, 'floor_code', _this15.setData.floor_code);

            _this15.getFloor(_this15.formModel.floor_code);
          });
        });
      }
    }
  },
  created: function created() {
    this.init();
  },
  destroyed: function destroyed() {
    if (this.realtimeint) {
      clearInterval(this.realtimeint);
    }
  }
};